import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TablaCentrosComponent } from './components/portal-inproeco/centro/tabla-centros/tabla-centros.component';
import { TablaClientesComponent } from './components/portal-inproeco/cliente/tabla-clientes/tabla-clientes.component';
import { TablaContratistasComponent } from './components/portal-inproeco/contratista/tabla-contratistas/tabla-contratistas.component';
import { TablaGestoresComponent } from './components/portal-inproeco/gestor/tabla-gestores/tabla-gestores.component';
import { TablaInstalacionesComponent } from './components/portal-inproeco/instalacion/tabla-instalaciones/tabla-instalaciones.component';
import { TablaTransportistasComponent } from './components/portal-inproeco/transportista/tabla-transportistas/tabla-transportistas.component';
import { MainPortalClienteComponent } from './components/portal-cliente/main-portal-cliente/main-portal-cliente.component';
import { GeneralPortalInproecoComponent } from './components/portal-inproeco/general-portal-inproeco/general-portal-inproeco.component';
import { TablaUsuariosInproecoComponent } from './components/portal-inproeco/usuarios/tabla-usuarios-inproeco/tabla-usuarios-inproeco.component';
import { LoginComponent } from './components/login/login.component';
import { InicioEntidadesComponent } from './components/inicio-entidades/inicio-entidades.component';
import { MyDoughnutChartComponent } from './my-doughnut-chart/my-doughnut-chart.component';
import { NuevoGestorComponent } from './components/portal-inproeco/gestor/formularios/nuevo-gestor/nuevo-gestor.component';
import { AltaXtensaBasicaFormComponent } from './components/alta-xtensa-basica-form/alta-xtensa-basica-form.component';
import { GeneralPortalClienteComponent } from 'src/app/components/portal-cliente/general-portal-cliente/general-portal-cliente.component';
import { InicioEntidadesClienteComponent } from 'src/app/components/portal-cliente/inicio/inicio-entidades-cliente/inicio-entidades-cliente.component';
import { TablaContratistaClienteComponent } from 'src/app/components/portal-cliente/contratista/tabla-contratista-cliente/tabla-contratista-cliente.component';
import { TablaCentrosClienteComponent } from 'src/app/components/portal-cliente/centros/tabla-centros-cliente/tabla-centros-cliente.component';
import { TablaGestoresClienteComponent } from 'src/app/components/portal-cliente/gestores/tabla-gestores-cliente/tabla-gestores-cliente.component';
import { TablaInstalacionesClienteComponent } from 'src/app/components/portal-cliente/instalaciones/tabla-instalaciones-cliente/tabla-instalaciones-cliente.component';
import { TablaTransportistaClienteComponent } from 'src/app/components/portal-cliente/transportistas/tabla-transportista-cliente/tabla-transportista-cliente.component';
import {TablaDocumentacionComponent} from 'src/app/components/portal-inproeco/documentacion/tabla-documentacion/tabla-documentacion.component'
import {ZonasGruposComponent} from 'src/app/components/portal-cliente/zonas-grupos/zonas-grupos.component'

//CONTRATISTA
import { GeneralPortalContratistaComponent } from './components/portal-contratista/general-portal-contratista/general-portal-contratista.component';
import { TablaCentrosContratistaComponent } from './components/portal-contratista/centro/tabla-centros-contratista/tabla-centros-contratista.component';
import { TablaGestoresContratistaComponent } from './components/portal-contratista/gestor/tabla-gestores-contratista/tabla-gestores-contratista.component';
import { TablaTransportistasContratistaComponent } from './components/portal-contratista/transportista/tabla-transportistas-contratista/tabla-transportistas-contratista.component';
import { TablaClientesContratistaComponent } from './components/portal-contratista/cliente/tabla-clientes-contratista/tabla-clientes-contratista.component';
import { TablaInstalacionesContratistaComponent } from './components/portal-contratista/instalacion/tabla-instalaciones-contratista/tabla-instalaciones-contratista.component';
import { TablaUsuariosContratistaComponent } from './components/portal-contratista/usuario/tabla-usuarios-contratista/tabla-usuarios-contratista.component';
import { InicioEntidadContratistaComponent } from './components/portal-contratista/inicio-entidad-contratista/inicio-entidad-contratista.component';
import { DetallePerfilComponent } from './components/portal-cliente/detalle-perfil/detalle-perfil-cliente.component';
import { XtensaAmpliadaComponent } from './components/xtensa-ampliada/xtensa-ampliada.component';
import { PerfilContratistaComponent } from './components/portal-contratista/perfil/perfil-contratista/perfil-contratista.component';
import { TablaValidacionesComponent } from './components/portal-inproeco/validacion/tabla-validaciones/tabla-validaciones.component';
import { DetallePerfilContratistaComponent } from './components/portal-contratista/detalle-perfil-contratista/detalle-perfil-contratista.component';
import { InicioInproecoComponent} from './components/portal-inproeco/inicio-inproeco/inicio-inproeco.component'
import { TablaProximosCaducarComponent } from './components/portal-inproeco/documentacion/tabla-proximos-caducar/tabla-proximos-caducar.component';
import { DocPropiaComponent } from './components/portal-contratista/doc-propia/doc-propia.component';
import { LoginActivateGuard } from './guards/login-activate.guard';
import { ClienteActivateGuard } from './guards/cliente-activate.guard';
import { ContratistaActivateGuard } from './guards/contratista-activate.guard';
import { InproecoActivateGuard } from './guards/inproeco-activate.guard';
import { RecuperarPasswordComponent } from './components/recuperar-password/recuperar-password.component';
import { GestionComponent } from './components/portal-cliente/gestion/gestion.component';
import { FacturacionComponent } from './components/portal-inproeco/facturacion/facturacion.component';
import { LicenciasComponent } from './components/portal-contratista/licencias/licencias.component';
import { InvitacionesComponent } from './components/portal-contratista/invitaciones/invitaciones.component';
import { FacturacionContratistaComponent } from './components/portal-contratista/facturacion-contratista/facturacion-contratista.component';
import { PopupLicenciaCaducadaComponent } from './components/portal-contratista/licencias/popup-licencia-caducada/popup-licencia-caducada.component';
import { PagoOkComponent } from './components/portal-contratista/pago-ok/pago-ok.component';
import { TablaAdicValidacionesComponent } from './components/portal-inproeco/validacion/tabla-adic-validaciones/tabla-adic-validaciones.component';

const routes: Routes = [
 {
    path: '',
    component: LoginComponent
  },
  {
    path: 'resetPassword',
    component: RecuperarPasswordComponent
  },
  {
    path: 'xtensaBasica',
    component: AltaXtensaBasicaFormComponent
  },
  {
    path: 'xtensa-ampliada',
    component: XtensaAmpliadaComponent    
  }, 
  {
    path: 'cliente',
    canActivate:[LoginActivateGuard, ClienteActivateGuard],
    component: GeneralPortalClienteComponent,
    children: [
      {
        path: 'perfil',
        component: DetallePerfilComponent
      },
       {
      path: 'inicio',
      component: MyDoughnutChartComponent
       },
      {
        path: 'estado',
        component: InicioEntidadesClienteComponent
      },
       {
        path: 'contratistas',
        component: TablaContratistaClienteComponent
      },
       {
        path: 'centros',
        component: TablaCentrosClienteComponent
      },
       {
        path: 'gestores',
        component: TablaGestoresClienteComponent
      },
       {
        path: 'instalaciones',
        component: TablaInstalacionesClienteComponent
      },
      {
        path: 'transportista',
        component: TablaTransportistaClienteComponent
      },
      {
        path: 'zonasgrupos',
        component: ZonasGruposComponent
      },
      {
        path: 'gestion',
        component: GestionComponent
      },
    
    ]
  }, 
 /*  {
    path: '',
    pathMatch: 'full'
    component: Login
  }, */
  { path: 'inproeco',
    component: GeneralPortalInproecoComponent,
    canActivate:[LoginActivateGuard, InproecoActivateGuard],
    children: [
      
      {
        path: 'estado',
        component: InicioEntidadesComponent
      },
      {
    path: 'estado/instalaciones',
    component: TablaInstalacionesComponent
  },
  {
    path: 'estado/documentacion-caducada',
    component: TablaDocumentacionComponent
  },
  {
    path: 'estado/documentacion-proxima',
    component: TablaProximosCaducarComponent
  },
  {
    path: 'estado/pendientes',
    component: TablaValidacionesComponent
  },
  {
    path: 'estado/adicional-pendientes',
    component: TablaAdicValidacionesComponent
  },
  {
    path: 'estado/clientes',
    component: TablaClientesComponent
  },
  {
    path: 'estado/centros',
    component: TablaCentrosComponent
  },
  {
    path: 'estado/contratistas',
    component: TablaContratistasComponent
  },
  {
    path: 'estado/gestores',
    component: TablaGestoresComponent,
    children: [
      {
        path: 'nuevo',
        component: NuevoGestorComponent
      }
    ]
  },
  {
    path: 'estado/transportistas',
    component: TablaTransportistasComponent
  },
  {
    path: 'usuarios',
    component: TablaUsuariosInproecoComponent
  },
  {
    path: 'facturacion',
    component: FacturacionComponent
  },
  {
    path: 'inicio',
    component: InicioInproecoComponent
  }

  ]
  },
  {
    path: 'contratista',
    component: GeneralPortalContratistaComponent,
    canActivate:[LoginActivateGuard, ContratistaActivateGuard],
    children: [
      {
        path: 'docpropia',
        component: DocPropiaComponent
      },
       {
        path: 'perfil',
        component: DetallePerfilContratistaComponent
      },
      {
        path: 'inicio',
        component: InicioEntidadContratistaComponent
      },
      {
        path: 'licencias',
        component: LicenciasComponent
      },
      {
        path: 'facturas',
        component: FacturacionContratistaComponent
      },
      {
        path: 'invitaciones',
        component: InvitacionesComponent
      },
      {
        path: 'pagoOk',
        component: PagoOkComponent
      },
      {
        path: 'estado',
        component: InicioEntidadContratistaComponent
      },
      {
        path: 'estado/instalaciones',
        component: TablaInstalacionesContratistaComponent
      },
      {
        path: 'estado/clientes',
        component: TablaClientesContratistaComponent
      },
      {
        path: 'estado/centros',
        component: TablaCentrosContratistaComponent
      },
      {
        path: 'estado/gestores',
        component: TablaGestoresContratistaComponent,
        children: [
          {
            path: 'nuevo',
            component: NuevoGestorComponent
          }
        ]
      },
      {
        path: 'estado/transportistas',
        component: TablaTransportistasContratistaComponent
      },
      {
        path: 'usuario',
        component: TablaUsuariosContratistaComponent
      },
      {
        path: 'inicio',
        component: MyDoughnutChartComponent
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
